import styled from 'styled-components';
import {
  MobileFrameHeaderHeight,
  FrameSidebarWidth,
  FrameHeaderHeight,
} from 'styles/constants';
import { customMedia } from 'styles/utils';

export const TabsWrapperStyled = styled.div`
  z-index: 1007;
  position: fixed;
  left: ${props => props.left + FrameSidebarWidth}px;
  top: ${FrameHeaderHeight}px;
  ${customMedia.lessThan('medium')`
    left: 0;
    top: ${MobileFrameHeaderHeight}px;
  `}
  right: 0;
  width: 100%;
  margin-top: ${props => props.theme.space[2]};
  height: ${props => props.tabHeight}px;
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const CadViewerStyled = styled.div`
  pointer-events: none;
  position: fixed;
  right: 0;
  top: ${FrameHeaderHeight}px;
  left: ${FrameSidebarWidth}px;
  ${customMedia.lessThan('medium')`
    left: 0;
  `}
  margin-left: 0;
  margin-right: 0;
  height: 100%;
  z-index: 1001;
  overflow: hidden;
`;

export const PreviewCadViewerStyled = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  min-height: 400px;
  max-height: ${props => props.maxHeight && `${props.maxHeight}px`};
  max-width: ${props => props.maxWidth && `${props.maxWidth}px`};
  top: 0;
  left: ${FrameSidebarWidth}px;
  ${customMedia.lessThan('medium')`
    left: 0;
  `}
  overflow: hidden;
`;

export const CadViewerWrapper = styled.section`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: ${FrameSidebarWidth}px;
  ${customMedia.lessThan('medium')`
    left: 0;
  `}
  width: calc(100% - ${FrameSidebarWidth}px);
  ${customMedia.lessThan('medium')`
    width: 100%;
    `}
  height: 100%;
  background-color: white;
  font-family: 'HelveticaNowDisplay';
  /* FIXME: remove this tweak once new viewer can be merged with new-brand branch. */
  &&& {
    [data-id='tooltip'] {
      border-radius: 0;
    }
  }
`;
